var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.suggestedAnchor.presenceType == 1)?_c('v-icon',{staticClass:"green--text",attrs:{"small":""}},[_vm._v(" mdi-checkbox-outline ")]):(_vm.suggestedAnchor.presenceType == 2)?_c('v-icon',{staticClass:"orange--text",attrs:{"label":"Link was removed recently","small":""}},[_vm._v(" mdi-alert-box-outline ")]):_vm._e(),_c('router-link',{attrs:{"to":{
      name: 'checkList-keyword-pages',
      params: {
        domain: _vm.domain,
        propertyId: _vm.propertyId,
        keywordId: _vm.suggestedAnchor.id,
        query: _vm.suggestedAnchor.query,
      },
    }}},[_vm._v(" "+_vm._s(_vm.getKeywordDisplayText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }